export default __webpack_public_path__ + "static/logo_gs-28df3c002755ed1a8027d27e94a0e553.svg";